import Vue from "vue"
import App from "./app.vue"
import { Toast } from "vant"

import "@/assets/reset.css"
import "vant/lib/index.css"
import "@/utils/rem"

async function BootStrap() {
  Vue.use(Toast)
  new Vue({
    el: "#app",
    render: (h) => h(App)
  })
}

BootStrap()
